import { render } from "./BoardVideos.vue?vue&type=template&id=33804a8c"
import script from "./BoardVideos.vue?vue&type=script&lang=js"
export * from "./BoardVideos.vue?vue&type=script&lang=js"

import "./BoardVideos.vue?vue&type=style&index=0&id=33804a8c&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__